"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Msal = __importStar(require("msal"));
const Config_1 = __importDefault(require("../Config"));
const msal = new Msal.UserAgentApplication(Config_1.default.msal);
const scopes = Config_1.default.authScopes;
exports.login = async () => {
    await msal.loginPopup({ scopes: scopes.graphApi });
};
exports.logout = () => {
    msal.logout();
};
exports.aquireToken = async (key) => {
    var _a, _b;
    try {
        return await msal.acquireTokenSilent({ scopes: scopes[key] });
    }
    catch (error) {
        if (((_a = error.errorMessage) === null || _a === void 0 ? void 0 : _a.startsWith("interaction_required")) || ((_b = error.name) === null || _b === void 0 ? void 0 : _b.startsWith("InteractionRequiredAuthError"))) {
            return await msal.acquireTokenPopup({ scopes: scopes[key] });
        }
        else {
            throw error;
        }
    }
};
exports.getAccessToken = async (key) => {
    const token = await exports.aquireToken(key);
    return token.accessToken;
};
